import type { SVGProps } from 'react'

export const Chevron = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 28 50'
    fill='none'
    style={{ fill: 'none' }}
    {...props}
  >
    <path
      d='M3.55075 4.29358C4.13169 5.06088 14.821 14.4877 21.6761 20.6261C24.8132 23.3664 24.697 28.0798 21.6761 30.7105L3.66694 46.3853'
      strokeWidth='7'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
  </svg>
)

Chevron.toString = () => 'chevron'
